(function () {
	function enhanceProductCards(root) {
		if (!root) {
			return;
		}

		root.querySelectorAll('.card-product, product-card.card-product').forEach((card) => {
			const media = card.querySelector('.card-media');
			const badge = card.querySelector('.card-footer-intro .badge-stock:not(.card-product__media-badge)');

			if (!media || !badge || media.contains(badge)) {
				return;
			}

			media.appendChild(badge);
			badge.classList.add('card-product__media-badge');
		});
	}

	function onReady() {
		enhanceProductCards(document);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', onReady);
	} else {
		onReady();
	}

	document.addEventListener('shopify:section:load', (event) => {
		enhanceProductCards(event.target);
	});

	const grid = document.getElementById('ProductGridContainer');

	if (grid && typeof MutationObserver !== 'undefined') {
		const observer = new MutationObserver(() => {
			enhanceProductCards(grid);
		});

		observer.observe(grid, { childList: true, subtree: true });
	}
})();
